export function isNonEmptyString(value: unknown): value is string {
  return Boolean(value) && typeof value === 'string'
}

export function parseNonEmptyString(value: unknown) {
  if (isNonEmptyString(value)) {
    const trimmed = value.trim()

    if (trimmed) return trimmed
  }

  throw new Error('Not non-empty string')
}

export function getArray<T>(array: unknown, parse: (value: unknown) => T) {
  const items: T[] = []

  if (Array.isArray(array)) {
    for (const item of array) {
      try {
        items.push(parse(item))
      } catch {
        // pass
      }
    }
  }

  return items
}

export function getNonEmptyStringArray(array: unknown) {
  return getArray(array, parseNonEmptyString)
}
